import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  fullWidth?: boolean;
  className?: string;
}
export function Button({
  children,
  href,
  onClick,
  fullWidth,
  className = ''
}: ButtonProps) {
  const baseClasses = `inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-white bg-teal-600 rounded-lg hover:bg-teal-700 transition-all duration-200 shadow-lg hover:shadow-xl ${fullWidth ? 'w-full' : ''} ${className}`;
  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!href || !href.startsWith('#')) return;
    e.preventDefault();
    const id = href.slice(1);
    const target = document.getElementById(id);
    if (!target) return;
    const rect = target.getBoundingClientRect();
    // Scroll past the top of the section so part of the order bump peeks into view
    const extraScroll = 220;
    const scrollTo = window.scrollY + rect.top + extraScroll;
    window.scrollTo({
      top: scrollTo,
      behavior: 'smooth'
    });
  };
  if (href) {
    // Check if it's an external link (starts with http)
    const isExternal = href.startsWith('http');
    const isAnchor = href.startsWith('#');
    return <a href={href} className={baseClasses} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} onClick={isAnchor ? handleAnchorClick : undefined} data-id="element-50">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={baseClasses} data-id="element-51">
      {children}
    </button>;
}